var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsHelpdesk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 129,
    viewBox: "0 0 128 129",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-710-202H440v754H-710z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M82.804 59.295c0-3.372-1.177-6.647-3.333-9.235-2.628-3.157-6.687-4.98-11.157-4.98h-9.589c-4.45 0-8.51 1.823-11.156 4.98a14.432 14.432 0 0 0-3.334 9.235v8.275H31.392v9.647h3.216v30.53h4.823v3.215h3.216v-3.216h41.765v3.216h3.215v-3.216h4.824v-30.53h3.216V67.57H82.824v-4.824l-.02-3.45zM52.274 30.63c0 6.196 5.04 11.255 11.255 11.255 6.216 0 11.255-5.04 11.255-11.255 0-5.647-4.784-11.145-11.255-11.275-6.47-.13-11.254 5.628-11.254 11.275zm19.275 0c0 4.431-3.608 8.039-8.04 8.039-4.43 0-8.038-3.608-8.038-8.04 0-4.43 3.607-8.039 8.039-8.039 4.431 0 8.039 3.608 8.039 8.04zm17.686 73.902H37.824V77.217h51.411v27.314zm3.216-33.726v3.216H34.608v-3.216H92.45zM74.765 67.59V59.55h-3.216v8.04H55.49v-8.04h-3.215v8.04H47.45v-8.275c0-2.628.922-5.177 2.588-7.177 2.02-2.431 5.177-3.823 8.686-3.823h9.589c3.49 0 6.666 1.392 8.686 3.823a11.308 11.308 0 0 1 2.588 7.177v8.274h-4.823z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.921 85.256h3.216v3.216h-3.216zM68.353 85.256h3.216v3.216h-3.216zM55.49 85.256h3.216v3.216H55.49z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsHelpdesk);
export default __webpack_public_path__ + "static/media/icons-helpdesk.859483000df5b9e49f3724bafcc39c22.svg";
export { ForwardRef as ReactComponent };